import React, { useEffect, useState } from "react";
import api from "utils/api";
import { formatPrice } from "constants/massages";
import "styles/konto.css";

const bookingStatus = {
  "pending-payment": "Zahlung ausstehend",
  "reserved-awaiting-payment": "Zahlung ausstehend",
  "awaiting-immediate-payment": "Zahlung ausstehend",
  "pending-email-verification": "E-Mail-Bestätigung ausstehend",
  "pending-employee-confirmation": "Mitarbeiterbestätigung ausstehend",
  confirmed: "Bestätigt",
  completed: "Abgeschlossen",
  cancelled: "Storniert",
  expired: "Abgelaufen",
  "no-show": "Nicht erschienen",
};

const dateLabel = (value) => value
  ? new Intl.DateTimeFormat("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" }).format(new Date(value))
  : "";

const ReferralBookings = () => {
  const [referrals, setReferrals] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    api.get("/auth/referrals")
      .then(({ data }) => { if (active) setReferrals(data.referrals || []); })
      .catch(() => { if (active) setError("Empfehlungen konnten nicht geladen werden."); });
    return () => { active = false; };
  }, []);

  return (
    <section className="konto-referral-card konto-referral-people" aria-label="Geworbene Kunden">
      <div className="konto-referral-head">
        <h2>Deine Empfehlungen</h2>
        <p>Hier siehst du registrierte Kunden und ihre Buchungen bei Dr. Hoffmann.</p>
      </div>
      {error && <p role="alert">{error}</p>}
      {!error && referrals === null && <p>Empfehlungen werden geladen…</p>}
      {!error && referrals?.length === 0 && <p>Noch keine Registrierung über deinen Link.</p>}
      {referrals?.map((person) => (
        <article className="konto-referral-person" key={person.id}>
          <div className="konto-referral-person__head">
            <div>
              <strong>{person.name || "Kunde"}</strong>
              <small>Registriert am {dateLabel(person.registeredAt)}</small>
            </div>
            <span>{person.bookings.length ? `${person.bookings.length} Buchung${person.bookings.length === 1 ? "" : "en"}` : "Noch keine Buchung"}</span>
          </div>
          {person.bookings.length > 0 && (
            <ul className="konto-referral-bookings">
              {person.bookings.map((booking) => (
                <li key={booking.id}>
                  <div>
                    <strong>{booking.service}</strong>
                    <small>Gebucht am {dateLabel(booking.bookedAt)} · {bookingStatus[booking.status] || booking.status}</small>
                  </div>
                  <div className="konto-referral-booking-price">
                    <strong>{formatPrice(booking.priceCents)}</strong>
                    <small>{booking.paymentStatus === "paid" ? "Bezahlt" : booking.paymentStatus === "refunded" ? "Erstattet" : "Zahlung offen"}</small>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </article>
      ))}
    </section>
  );
};

export default ReferralBookings;
